// import axios from "axios";

// export const axiosInstance = axios.create();

// export const apiConnector = (method, url, bodyData, headers, params) => {
//     return axiosInstance({
//         method: `${method}`,
//         url: `${url}`,
//         data: bodyData ? bodyData : null,
//         headers: headers ? { ...headers, Authorization: `Bearer ${localStorage.getItem("token")}` } : { Authorization: `Bearer ${localStorage.getItem("token")}` },
//         params: params ? params : null,
//     });
// };

import axios from "axios";

// Create Axios instance
export const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000",
  });


export const apiConnector = async (method, endpoint, bodyData = null, headers = {}, params = null) => {
    try {
        const response = await axiosInstance({
            method,
            url: endpoint, // Bas endpoint pass karein, full URL nahi
            data: bodyData,
            headers: {
                ...headers,
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            params,
        });
    
        return response;
    } catch (error) {
        console.error("API Connector Error:", error?.response?.data || error.message);
        throw error;
    }
};


